/* template */
<template><page><base-container :class='["cube-checkbox-modal-page"]'><checkbox-modal-default :class='["demo-item"]'/><checkbox-modal-option-conf :class='["demo-item"]'/><checkbox-modal-cancel-btn :class='["demo-item"]'/><checkbox-modal-slots :class='["demo-item"]'/></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_144c8809"}'>
.cube-checkbox-modal-page
  .demo-item:not(:last-child)
    display block
    margin-bottom: 10px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_144c8809"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_144c8809"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_144c8809"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'checkbox-modal-default':getComponent(require("./checkbox-modal-default.mpx?isComponent&outputPath=components%2Fcheckbox-modal-default4eb0b56e%2Findex")),'checkbox-modal-option-conf':getComponent(require("./checkbox-modal-option-conf.mpx?isComponent&outputPath=components%2Fcheckbox-modal-option-confff421fae%2Findex")),'checkbox-modal-cancel-btn':getComponent(require("./checkbox-modal-cancel-btn.mpx?isComponent&outputPath=components%2Fcheckbox-modal-cancel-btn70b5c1ac%2Findex")),'checkbox-modal-slots':getComponent(require("./checkbox-modal-slots.mpx?isComponent&outputPath=components%2Fcheckbox-modal-slotsa654863c%2Findex")),'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>